import React, { useState, useEffect, useRef } from 'react'
import PageHeader from '../Elements/UI/PageHeader'
import { toast } from 'react-toastify'
import './Construction.css'

const STORAGE_KEY = 'bl_construction_subscribed'

function Construction() {
  const wideBlockRef = useRef()
  const [subscribed, setSubscribed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch (e) {
      return false
    }
  })

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  const handleToggleNotify = () => {
    const next = !subscribed
    setSubscribed(next)
    try {
      localStorage.setItem(STORAGE_KEY, String(next))
    } catch (e) {}

    if (next) {
      toast.success('You will be notified when this feature goes live!')
    } else {
      toast.info('Notification preference updated.')
    }
  }

  return (
    <div id="appCapsule" className="bl-construction-page">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef} style={{ overflowY: 'auto' }}>
          <PageHeader
            title="Construction"
            subtitle="Society development updates"
          />

          {/* Minimal Centered Animated Coming Soon Card */}
          <div className="bl-coming-soon-card">
            <div className="bl-hero-badge-wrap">
              <div className="bl-hero-badge-ring"></div>
              <div className="bl-hero-badge-icon">
                <ion-icon name="construct" aria-hidden="true"></ion-icon>
              </div>
              <span className="bl-hero-sparkle top-right">✦</span>
              <span className="bl-hero-sparkle bottom-left">✦</span>
            </div>

            {/* <div className="bl-live-status-pill">
              <span className="bl-pulse-dot"></span>
              UNDER DEVELOPMENT
            </div> */}

            <h2 className="bl-coming-soon-title">Coming Soon</h2>

            {/* <p className="bl-coming-soon-desc">
              We are working on this feature to bring you real-time updates and enhancements.
              Stay tuned, something great is on the way!
            </p> */}
{/* 
            <div className="bl-hero-actions">
              <button
                type="button"
                className={`bl-btn-notify${subscribed ? ' is-subscribed' : ''}`}
                onClick={handleToggleNotify}
              >
                <ion-icon
                  name={subscribed ? 'checkmark-circle' : 'notifications-outline'}
                  aria-hidden="true"
                ></ion-icon>
                <span>{subscribed ? 'Subscribed for Updates' : 'Notify Me When Ready'}</span>
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Construction
